import React from 'react';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export default function Phase2EntityType({ wizardData, setWizardData, onNext, onPrev }) {
  const entityOptions = [
    { value: 'national', label: 'National Government Agency (NGA)', desc: 'Department, bureau, office, or instrumentality' },
    { value: 'lgu', label: 'Local Government Unit (LGU)', desc: 'Provincial, city, municipal, or barangay government' },
    { value: 'gocc', label: 'GOCC', desc: 'Government-owned or controlled corporation' },
    { value: 'suc', label: 'SUC', desc: 'State university or college' },
    { value: 'other', label: 'Other GI', desc: 'Other government instrumentality' }
  ];

  return (
    <div className="space-y-6">
      <div>
        <Label className="text-lg font-semibold mb-4 block">What type of procuring entity are you?</Label>
        <RadioGroup value={wizardData.entityType} onValueChange={(value) => setWizardData({ ...wizardData, entityType: value })}>
          <div className="space-y-3">
            {entityOptions.map((option) => (
              <div key={option.value} className="flex items-center space-x-3 border rounded-lg p-4 hover:border-emerald-500 hover:bg-emerald-50 dark:hover:bg-emerald-900/10 transition-all cursor-pointer">
                <RadioGroupItem value={option.value} id={option.value} />
                <Label htmlFor={option.value} className="cursor-pointer flex-1">
                  <div>
                    <p className="font-medium">{option.label}</p>
                    <p className="text-sm text-slate-500">{option.desc}</p>
                  </div>
                </Label>
              </div>
            ))}
          </div>
        </RadioGroup>
      </div>
      <div className="flex gap-3">
        <Button variant="outline" onClick={onPrev} size="lg">
          <ChevronLeft className="w-4 h-4 mr-2" /> Back
        </Button>
        <Button onClick={onNext} className="flex-1 bg-emerald-600 hover:bg-emerald-700" size="lg">
          Next <ChevronRight className="w-4 h-4 ml-2" />
        </Button>
      </div>
    </div>
  );
}
